import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

import pathnames from "routes/pathnames";

// import api from "services/api";

// import serveRequestErrors from "common/serve-request-errors";

import REGEX from "constants/regex";
import ERRORS from "constants/errors";

// import ErrorResponseDto from "dto/services/error-response-dto";
import PageForgotPasswordDto from "dto/pages/authenticate/page-forgot-password-dto";

import AppInput from "components/app-input";
import AppButton from "components/app-button";
import AppAuthLayout from "components/pages/page-authenticate/app-auth-layout";

import logoIcon from "assets/images/components/app-side-nav/logo-atf.svg";

const PageForgotPassword = () => {
	const navigate = useNavigate();

	const formik = useFormik<PageForgotPasswordDto>({
		initialValues: { email: "" },
		validationSchema: yup.object({
			email: yup.string().matches(REGEX.EMAIL, ERRORS.EMAIL).required(ERRORS.REQUIRED),
		}),
		onSubmit: (values) => {
			onHandleSubmit(values);
		},
	});

	//prettier-ignore
	const onHandleSubmit = useCallback(async (values: PageForgotPasswordDto) => {
        /* Temporary comment out until integration done
        let response = null;

        try {
            const payload = {
                email: values.email,
            };

            response = await api.post.authenticate.forgotPassword(payload);
        } catch (error) {
            const err = error as Error | ErrorResponseDto;

            serveRequestErrors(err);
        }

        if (response) {
            navigate(pathnames.default);
        }
        */

        navigate(pathnames.default);
    }, [navigate]);

	const onHandleBackToLogin = () => {
		navigate(pathnames.default);
	};

	return (
		<AppAuthLayout>
			<div className="page-login">
				<div className="login">
					<form className="login__form" onSubmit={formik.handleSubmit}>
						<img className="login__logo" src={logoIcon} alt="company-logo" />

						<h1 className="login__title">Reset Password</h1>

						<p className="login__description">Web Content Management System</p>

						<AppInput type="text" name="email" placeholder="Username or Email Address" value={formik.values.email} error={formik.errors.email} touched={formik.touched.email} onChange={formik.handleChange} />

						<div className="login__button-container">
							<AppButton type="button" label="Back to login" onClick={onHandleBackToLogin} disabled={formik.isSubmitting} outline smallRadius />

							<AppButton type="submit" label="Submit" disabled={formik.isSubmitting} smallRadius />
						</div>
					</form>
				</div>
			</div>
		</AppAuthLayout>
	);
};

export default PageForgotPassword;
